var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Button } from '@chakra-ui/button';
import { Text, Flex } from '@chakra-ui/layout';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, } from '@chakra-ui/modal';
import { Input } from '@chakra-ui/input';
import { chunk } from 'lodash';
import * as Papa from 'papaparse';
import pluralize from 'pluralize';
import { FiUpload } from 'react-icons/fi';
import { exportToCsv } from '@obtainly/utils';
import { useMutateModel } from '@obtainly/http';
import { useToast } from 'src/core/hooks';
export var Importer = function (props) {
    var toast = useToast().toast;
    var _a = React.useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var fileInput = React.useRef();
    var _b = React.useState(false), isUploading = _b[0], setIsUploading = _b[1];
    var _c = React.useState(), items = _c[0], setItems = _c[1];
    var createModels = useMutateModel("".concat(props.model, ".create_bulk"));
    var doUpload = function () {
        setIsUploading(true);
        var chunks = chunk(items, 125);
        var _loop_1 = function (i) {
            var payload = {};
            var _loop_2 = function (j) {
                Object.keys(chunks[i][j]).forEach(function (key) {
                    if (payload[key])
                        payload[key].push(chunks[i][j][key]);
                    else
                        payload[key] = [chunks[i][j][key]];
                });
            };
            // Loop through items in a chunk
            for (var j = 0; j < chunks[i].length; j++) {
                _loop_2(j);
            }
            createModels.mutate(payload, {
                onSuccess: function () {
                    var _a;
                    toast({ description: 'Import successful', status: 'success' });
                    (_a = props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props);
                    setModalOpen(false);
                },
                onError: function (_a) {
                    var message = _a.message;
                    toast({ description: message, status: 'error' });
                },
                onSettled: function () {
                    if (i === chunks.length - 1)
                        setIsUploading(false);
                },
            });
        };
        for (var i = 0; i < chunks.length; i++) {
            _loop_1(i);
        }
    };
    var downloadSampleCSV = function () {
        var csv = props.columns
            .filter(function (i) { return !(i === null || i === void 0 ? void 0 : i.value); })
            .map(function (i) { return i.label; })
            .join(',');
        exportToCsv(csv, "Obtainly ".concat(pluralize(props.label, 2), " Template"));
    };
    var parseFile = function (file) {
        Papa.parse(file, {
            delimiter: '',
            newline: undefined,
            quoteChar: '"',
            escapeChar: '"',
            // headers: true,
            complete: function (_a) {
                var data = _a.data;
                var items = [];
                var _loop_3 = function (i) {
                    /**
                     * Two things:
                     * 1. Let's skip the first row, it's usually the header
                     * 2. If we have less than the expected columns for a row, skip
                     */
                    var actual = data[i].filter(function (i) { return i !== ''; });
                    var expected = props.columns.filter(function (i) { return !(i === null || i === void 0 ? void 0 : i.value); });
                    if (i !== 0 && actual.length === expected.length) {
                        var item_1 = {};
                        props.columns.forEach(function (column, columnIndex) {
                            item_1[column.id] = (column === null || column === void 0 ? void 0 : column.value) || data[i][columnIndex];
                        });
                        items.push(item_1);
                    }
                    if (i === data.length - 1)
                        setItems(items);
                };
                for (var i = 0; i < data.length; i++) {
                    _loop_3(i);
                }
            },
        });
        fileInput.current.value = null; // reset file input
    };
    var handleFileChange = function (event) {
        var files = event.target.files;
        if (!(files === null || files === void 0 ? void 0 : files.length))
            return;
        parseFile(files[0]);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ size: "sm", alignItems: "center", variant: "outline", leftIcon: _jsx(FiUpload, { style: { position: 'relative', top: '1px' } }, void 0), display: ['none', 'block'], onClick: function () { return setModalOpen(true); } }, { children: "Import" }), void 0), _jsxs(Modal, __assign({ isOpen: modalOpen, onClose: function () { return setModalOpen(false); } }, { children: [_jsx(ModalOverlay, {}, void 0), _jsxs(ModalContent, { children: [_jsxs(ModalHeader, { children: ["Import ", pluralize(props.label, 2), " from CSV"] }, void 0), _jsx(ModalCloseButton, {}, void 0), _jsx(ModalBody, __assign({ display: "none" }, { children: _jsx(Text, __assign({ color: "gray.600" }, { children: "This feature is not available at the moment." }), void 0) }), void 0), _jsxs(ModalBody, { children: [_jsxs(Text, __assign({ mb: 5 }, { children: [_jsx(Text, __assign({ as: "span", cursor: "pointer", color: "primary.600", textDecor: "underline", onClick: downloadSampleCSV }, { children: "Download a sample CSV" }), void 0), ' ', "to see an example of the required format."] }), void 0), _jsxs(Flex, __assign({ py: 10, gridGap: 2, bg: "gray.50", flexDir: "column", borderRadius: "8px", alignItems: "center" }, { children: [_jsxs(Flex, __assign({ w: "48px", h: "48px", bg: "gray.500", color: "white", alignItems: "center", borderRadius: 99999, justifyContent: "center" }, { children: [_jsx(Input, { type: "file", accept: ".csv", display: "none", onChange: handleFileChange, ref: fileInput }, void 0), _jsx(FiUpload, { size: 20 }, void 0)] }), void 0), items && (items === null || items === void 0 ? void 0 : items.length) ? (_jsxs(Text, __assign({ mt: 2, color: "gray.600", fontSize: "sm" }, { children: [_jsx("b", { children: items.length }, void 0), " ", pluralize(props.label, items.length), ' ', "found in file."] }), void 0)) : items && !(items === null || items === void 0 ? void 0 : items.length) ? (_jsxs(Text, __assign({ mt: 2, color: "critical.600", fontSize: "sm" }, { children: ["No ", props.label, " found, please check the file and try again."] }), void 0)) : null, _jsx(Button, __assign({ size: "sm", variant: "outline", isDisabled: isUploading, onClick: function () { return fileInput.current.click(); } }, { children: "Upload File" }), void 0)] }), void 0)] }, void 0), _jsxs(ModalFooter, { children: [_jsx(Button, __assign({ mr: 3, size: "sm", variant: "outline", onClick: function () { return setModalOpen(false); } }, { children: "Cancel" }), void 0), _jsxs(Button, __assign({ size: "sm", colorScheme: "primary", onClick: function () { return doUpload(); }, isLoading: isUploading, isDisabled: isUploading || !(items === null || items === void 0 ? void 0 : items.length) }, { children: ["Import ", items === null || items === void 0 ? void 0 : items.length, " ", pluralize(props.label, items === null || items === void 0 ? void 0 : items.length)] }), void 0)] }, void 0)] }, void 0)] }), void 0)] }, void 0));
};
